import { getUserPreferences, hasNonDefaultPreferences } from "@/utils/userPreferences"

export function readGuestPrefsBeforeLogin() {
  const prefs = getUserPreferences()
  const hasPrefs = hasNonDefaultPreferences(prefs)
  return { prefs, hasPrefs }
}
